export const QUERY_INTEGRATIONS_QUICKBOOKS = "QUERY_INTEGRATIONS_QUICKBOOKS";
export const QUERY_INTEGRATIONS_QUICKBOOKS_SYNC_ACTIVITIES =
  "QUERY_INTEGRATIONS_QUICKBOOKS_SYNC_ACTIVITIES";
export const QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_ASSETS =
  "QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_ASSETS";
export const QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_EXPENSES =
  "QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_EXPENSES";
export const QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_LIABILITIES =
  "QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_LIABILITIES";
export const QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_REVENUES =
  "QUERY_INTEGRATIONS_QUICKBOOKS_ACCOUNT_REVENUES";
export const QUERY_INTEGRATIONS_QUICKBOOKS_CUSTOMERS =
  "QUERY_INTEGRATIONS_QUICKBOOKS_CUSTOMERS";
export const QUERY_INTEGRATIONS_QUICKBOOKS_ITEMS =
  "QUERY_INTEGRATIONS_QUICKBOOKS_ITEMS";
export const QUERY_INTEGRATIONS_QUICKBOOKS_VENDORS =
  "QUERY_INTEGRATIONS_QUICKBOOKS_VENDORS";
